<template>
	<div class="award">
		<div class="award__table award__list">
			<p class="award__notice">
				※ 어워드 수상제품 모듈은 제품 카테고리와 제품맵핑이 되어있어야만
				노출이 가능합니다.
			</p>
			<table class="simple-table">
				<thead>
					<tr>
						<th class="award__list__num">항번</th>
						<th class="award__list__name">3차카테고리명</th>
						<th class="award__list__sort">정렬순서</th>
						<th class="award__list__category">제품카테고리</th>
						<th class="award__list__btn">수정</th>
						<th class="award__list__btn">삭제</th>
						<th class="award__list__categoryNum">상품갯수</th>
						<th class="award__list__btn">제품맵핑</th>
					</tr>
				</thead>
				<tbody>
					<tr
						v-for="(third, idx) in thirdCategoryList"
						:key="third.idHitCategory"
					>
						<td class="award__list__num">
							{{ third.idHitCategory }}
						</td>
						<td class="award__list__name">
							<input
								v-model="third.categoryText"
								@input="getThirdCategory(idx, $event)"
								type="text"
							/>
						</td>
						<td class="award__list__sort">
							<input
								v-model="third.sortKey"
								@input="getSortKey(idx, $event)"
								type="text"
							/>
						</td>
						<td class="award__list__category">
							<div class="category__selector__box">
								<CategorySelector
									:award="true"
									@change="getThirdCategoryName($event, idx)"
									:reset="reset"
								/>
								<div class="category__button-wrapper">
									<button
										@click="addTarget(idx)"
										class="category__add"
									>
										<i class="fa fas fa-plus" />
									</button>
								</div>
							</div>
							<div class="category__seletor__list">
								<div
									v-for="(
										name, nameIdx
									) in getProductCategoryName[idx]"
									:key="nameIdx"
									class="category__seletor"
								>
									<template v-if="name">
										<div class="category__list">
											<span>{{ name }}</span>
											<button
												@click="
													removeProductCategory(
														idx,
														nameIdx
													)
												"
												class="category__name remove"
											>
												<i class="fa fas fa-minus"></i>
											</button>
										</div>
									</template>
								</div>
							</div>
						</td>
						<td class="award__list__btn">
							<button
								@click="modifyThirdCategory(idx)"
								class="btn orange"
							>
								수정
							</button>
						</td>
						<td class="award__list__btn">
							<button
								@click="deleteThirdCategory(idx)"
								class="btn gray"
								:disabled="!!third.productCount"
							>
								삭제
							</button>
						</td>
						<td class="award__list__categoryNum">
							{{ third.productCount }}개
						</td>
						<td class="award__list__btn">
							<button
								@click="moveProductMapping(idx)"
								class="btn mint"
							>
								맵핑
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>
<script>
	import { mapState, mapGetters } from 'vuex';
	import CategorySelector from '@/components/common/CategorySelector';

	export default {
		name: 'AwardThirdCategory',
		data() {
			return {
				categoryNameList: [],
				categorySortList: [],
				categoryMappingList: [],
				thirdProductCategory: [],
				reset: false,
			};
		},
		props: {
			awardId: {
				default: 0,
			},
		},
		components: {
			CategorySelector,
		},
		computed: {
			...mapState('award', ['thirdCategoryList']),
			...mapGetters({
				getThirdCategoryList: 'getThirdCategory',
			}),
			getProductCategoryName() {
				const productName = this.categoryMappingList.map(item => {
					if (Array.isArray(item)) {
						const name = item.map(id => {
							const findItem = this.getThirdCategoryList.find(
								item => item.id === Number(id)
							);
							return findItem ? findItem.name : undefined;
						});
						return name;
					} else {
						return undefined;
					}
				});

				return productName;
			},
		},
		watch: {
			thirdCategoryList() {
				this.thirdCategoryList.forEach((item, idx) => {
					this.categoryNameList[idx] = item.categoryText;
					this.categorySortList[idx] = item.sortKey;
					this.$set(
						this.categoryMappingList,
						idx,
						item.thirdcategorys?.split(',')
					);
				});
			},
			categoryMappingList() {
				this.getProductCategoryName;
			},
		},
		methods: {
			getThirdCategory: _.debounce(async function (index, event) {
				this.categoryNameList[index] = event.target.value;
			}, 500),

			getSortKey: _.debounce(async function (index, event) {
				this.categorySortList[index] = event.target.value;
			}, 500),

			async getList() {
				const { idHitProduct, idHitCategory } = this.$route.query;
				await this.$store.dispatch('award/getThirdCategory', {
					idHitProduct,
					idHitCategory,
				});
			},

			async modifyThirdCategory(index) {
				if (!confirm('정말 수정하시겠습니까?')) return;
				try {
					const number = this.thirdCategoryList[index].idHitCategory;
					const params = {
						categoryText: this.categoryNameList[index],
						sortKey: this.categorySortList[index],
						thirdCategoryIds: this.categoryMappingList[index],
					};
					await this.$axiosAdmin2.put(
						`/api/award/thirdcategory/${this.awardId}/${number}`,
						params
					);
					alert('수정되었습니다.');
					this.reset = true;
					this.getList();
				} catch (err) {
					console.error(err);
					alert(
						'수정 실패하였습니다. 지속적으로 문제 발생시 개발팀에 문의바랍니다.'
					);
				}
			},

			async deleteThirdCategory(index) {
				if (!confirm('정말 삭제하시겠습니까?')) return;
				try {
					const number = this.thirdCategoryList[index].idHitCategory;
					await this.$axiosAdmin2.delete(
						`/api/award/thirdcategory/${this.awardId}/${number}`
					);
					alert('삭제되었습니다.');
					this.getList();
				} catch (err) {
					console.error(err);
					alert(
						'삭제 실패하였습니다. 지속적으로 문제 발생시 개발팀에 문의바랍니다.'
					);
				}
			},

			async moveProductMapping(index) {
				const { idHitCategory } = this.$route.query;
				const number = this.thirdCategoryList[index].idHitCategory;
				this.$router.push(
					`/product/manage-awards/mappingProduct?idHitProduct=${this.awardId}&idHitCategory=${number}`
				);
			},
			getThirdCategoryName(category, idx) {
				const thirdCategory = category?.c3;
				this.thirdProductCategory[idx] = thirdCategory;
			},
			addTarget(idx) {
				const thirdCategoryIds = this.thirdProductCategory[idx]?.id;
				if (!thirdCategoryIds) {
					alert('3차 카테고리가 없습니다.');
					return;
				}
				if (Array.isArray(this.categoryMappingList[idx])) {
					if (
						this.categoryMappingList[idx].includes(
							String(thirdCategoryIds)
						)
					) {
						alert('이미 리스트에 포함되어 있습니다.');
						return;
					}
					this.categoryMappingList[idx].push(
						String(thirdCategoryIds)
					);
				} else {
					this.$set(this.categoryMappingList, idx, [
						String(thirdCategoryIds),
					]);
				}
			},
			removeProductCategory(listIdx, nameIdx) {
				this.categoryMappingList[listIdx].splice(nameIdx, 1);
			},
		},
	};
</script>
<style lang="scss" scoped>
	.award {
		&__table {
			margin-top: 20px;
			.simple-table {
				th {
					text-align: center;
					padding: 0;
				}
			}
		}
		&__notice {
			margin-bottom: 10px;
			color: #6e6e6e;
		}
		&__list {
			margin-top: 70px;
			&__btn {
				width: 30px;
				text-align: center;
				button {
					&:disabled {
						border: none;
					}
				}
			}
			&__num {
				width: 30px;
				text-align: center;
			}
			&__name {
				width: 300px;
			}
			&__sort {
				width: 70px;
			}
			&__category {
				width: 100px;
				text-align: center;
				.category__name {
					&.remove {
						background: #ff3860;
						font-size: 0.75rem;
						vertical-align: middle;
						width: 1.6em;
						height: 1.6em;
						border-radius: 50%;
						color: #fff;
						margin: 0 0 0 10px;
					}
				}
				.category__seletor {
					.category__list {
						margin-top: 10px;
						padding: 5px;
						border: 1px solid #e8e5e5;
						display: inline-block;
						border-radius: 10px;
						& + .category__list {
							margin-left: 3px;
						}
					}
				}
				.category__seletor__list {
					display: flex;
					gap: 10px;
					margin-top: 10px;
					flex-wrap: wrap;
				}
			}
			&__categoryNum {
				width: 100px;
				text-align: center;
			}
		}
	}
	.category__selector__box {
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #f9f6f6;
		padding: 12px;
		border-radius: 6px;
	}

	.category__button-wrapper {
		text-align: center;
		padding-left: 10px;
	}

	.category__add {
		background: $btn-blue;
		width: 1.6em;
		height: 1.6em;
		border-radius: 50%;
		color: #fff;
	}
</style>
